import { DisplayDossierOverviews } from '../../../resources/dossier/types';

type BudgetDisplayType = 'none' | 'insufficient' | 'partial' | 'all';

const BUDGET_SUM_PROJECTS_THRESHOLD = 0.75;

export const computeBudgetSummary = (value: DisplayDossierOverviews) => {
    let budgetDisplay: BudgetDisplayType;
    const projectsWithBudget = value.filter(
        ({ budget, project }) => budget || project.idealBudget?.totalInEuro,
    );
    const projectsWithBudgetRatio = projectsWithBudget.length / value.length;

    if (value.length === 0) {
        budgetDisplay = 'none';
    } else if (projectsWithBudgetRatio < BUDGET_SUM_PROJECTS_THRESHOLD) {
        budgetDisplay = 'insufficient';
    } else if (projectsWithBudgetRatio === 1) {
        budgetDisplay = 'all';
    } else {
        budgetDisplay = 'partial';
    }

    const totalBudget = projectsWithBudget.reduce(
        (acc, { project, budget: adjustedBudget }) =>
            acc + (adjustedBudget || project.idealBudget?.totalInEuro || 0),
        0,
    );

    return {
        budgetDisplay,
        totalBudget,
    };
};
